import { Component } from '@angular/core';
import { DashboardDataService } from '../Dashboard/dashboard.data.service';

@Component({
    selector: 'landing-selector',
    template: `
        @if (!showDashboard) {
          <landing></landing>
        }
        @if (showDashboard) {
          <dashboard></dashboard>
        }
        `,
    styleUrls: ['./landing.selector.component.scss'],
    standalone: false
})
export class LandingSelectorComponent {
    constructor(private dashboardDataService: DashboardDataService) {
        this.showDashboard = dashboardDataService.getShowDashBoardUserSetting();
    }

    showDashboard: boolean;
}
